module.exports = __webpack_public_path__ + "static/media/bulk_msil_vessel_sample.69025866.csv";